// Design System — InlineChipInput constants
export const INLINE_CHIP_INPUT_ICON = { ADD: 'icon-svg-plus' };
export const INLINE_CHIP_INPUT_KEY = { ENTER: 'Enter', ESCAPE: 'Escape' };
